<template>
	<div>
		<div class="bh-top">
			<div class="bh-muted">Accendi le fasce da mostrare in home e trascinale nell'ordine in cui devono comparire.</div>
			<v-spacer></v-spacer>
			<v-btn small outlined color="primary" :disabled="inOrdine" title="Rimette le fasce nell'ordine consigliato dal tema; accese e spente restano come sono" @click="$emit('riordina')">
				<v-icon left small>mdi-sort</v-icon>{{ inOrdine ? 'Già nell\'ordine del tema' : 'Ordina come il tema' }}
			</v-btn>
		</div>
		<draggable :list="blocchi.slice()" handle=".bh-grab" class="bh-list" @change="$emit('sposta', $event)">
			<div v-for="(item, index) in blocchi" :key="item.code || index" class="bh-row" :class="{ 'bh-row--off': !item.active }">
				<v-icon class="bh-grab" title="Trascina per cambiare l'ordine">mdi-drag</v-icon>
				<span class="bh-n">{{ index + 1 }}</span>
				<span class="bh-label">{{ item.label }}</span>
				<span v-if="note[item.code]" class="bh-muted">{{ note[item.code] }}</span>
				<v-spacer></v-spacer>
				<span class="bh-state">{{ item.active ? 'Visibile' : 'Nascosta' }}</span>
				<v-switch v-model="item.active" color="primary" dense hide-details class="mt-0 pt-0" />
			</div>
		</draggable>
	</div>
</template>

<script>
import Draggable from 'vuedraggable';

// le fasce della home (layout.homepage di Layout.vue): visibili/nascoste e ordine
export default {
	name: 'BlocchiHome',
	components: { Draggable },
	props: {
		blocchi: { type: Array, default: () => [] },
		// codici delle fasce nell'ordine consigliato dal tema
		ordine: { type: Array, default: () => [] },
	},
	computed: {
		// le fasce conosciute sono già nell'ordine del tema (quelle sconosciute non contano)
		inOrdine() {
			const pos = this.blocchi.map(b => this.ordine.indexOf(b.code)).filter(i => i >= 0);
			return pos.every((p, i) => i === 0 || pos[i - 1] < p);
		},
	},
	data() {
		return {
			// fasce che compaiono solo con la funzione corrispondente attiva
			note: {
				h13: 'serve «Pezzi disponibili» attivo',
				h16: 'serve la scheda a punti attiva',
				h17: 'serve «Confronta prodotti» attivo; compare solo a chi ha un confronto aperto',
			},
		};
	},
};
</script>

<style scoped>
.bh-muted {
	font-size: 12px;
	color: #5f6b7a;
}
.bh-top {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px;
	margin-bottom: 8px;
}
.bh-list {
	border: 1px solid #e1e7ef;
	border-radius: 10px;
	overflow: hidden;
	background: #fff;
}
.bh-row {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 6px 12px;
	min-height: 44px;
}
.bh-row + .bh-row {
	border-top: 1px solid #eef2f7;
}
.bh-row--off .bh-label {
	color: #8a96a3;
}
.bh-grab {
	cursor: grab;
	color: #8a96a3 !important;
}
.bh-n {
	width: 20px;
	font-size: 12px;
	font-weight: 700;
	color: #5f6b7a;
}
.bh-label {
	font-size: 14px;
	font-weight: 500;
	color: #1f2d3d;
}
.bh-state {
	font-size: 12px;
	color: #5f6b7a;
}
</style>
